import { render, staticRenderFns } from "./showOwnerRoom.vue?vue&type=template&id=a783510e&scoped=true"
import script from "./showOwnerRoom.vue?vue&type=script&lang=js"
export * from "./showOwnerRoom.vue?vue&type=script&lang=js"
import style0 from "./showOwnerRoom.vue?vue&type=style&index=0&id=a783510e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a783510e",
  null
  
)

export default component.exports